import { render, staticRenderFns } from "./loud_xin.vue?vue&type=template&id=56a07524&scoped=true"
import script from "./loud_xin.vue?vue&type=script&lang=js"
export * from "./loud_xin.vue?vue&type=script&lang=js"
import style0 from "./loud_xin.vue?vue&type=style&index=0&id=56a07524&prod&lang=css"
import style1 from "./loud_xin.vue?vue&type=style&index=1&id=56a07524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a07524",
  null
  
)

export default component.exports